import { render } from "./ChaptersPage.vue?vue&type=template&id=19611bd8"
import script from "./ChaptersPage.vue?vue&type=script&lang=js"
export * from "./ChaptersPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__